const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: '/guests',
    name: 'Guests',
    component: {
      template: '<div class="content-wrapper"><router-view></router-view></div>'
    },
    meta: {
      showInMenu: true,
      title: 'Гости',
      menuKey: 'Guests',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    redirect: 'guests',
    children: [
      {
        path: '',
        component: _import('guests/components/list'),
        name: 'Guests.list',
        meta: {
          menuKey: 'Guests',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'create',
        component: _import('guests/components/create'),
        name: 'Guests.create',
        meta: {
          menuKey: 'Guests',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'edit/:id',
        component: _import('guests/components/edit'),
        name: 'Guests.edit',
        meta: {
          menuKey: 'Guests',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id',
        component: _import('guests/components/info'),
        name: 'Guests.info',
        meta: {
          menuKey: 'Guests',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/guests/routes.js